class CookieHandlerComponent {

    constructor() {
        this.$cookieMessage = $('.cookie-alert');
        this.$accept = $('.acceptCookie');
        this.$info = $('.cookieInfo');
        this.checkCookieHasAccepted();
        this.acceptCookie();
        this.openInfo();
    }

    checkCookieHasAccepted() {

        if(this.getCookie('cookie-accepted') === "true") {
            this.$cookieMessage.fadeOut();
        }

    }

    acceptCookie() {
        let that = this;
        this.$accept.on('click', function () {
            that.setCookie('cookie-accepted', "true", 30);
            that.$cookieMessage.fadeOut();
        });
    }

    openInfo() {
        this.$info.on('click', function () {
            let URL = 'https://www.bizxpert.hu/data/pdf/bizexpert-adatvedelem.pdf';
            let win = window.open(URL, "_blank");
        });

    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }


}

new CookieHandlerComponent();

